import { Row, Col, Statistic, Flex } from 'antd';
import { useTranslation } from 'translations/hooks';
import { getLocale } from 'translations/locale';

import { useReportProdAnalyzeFilters } from 'business/shift-report/report-analyze/pages/production-analyze/providers/filters';
import { createNumberFormatter } from 'technical/format/number';
import { useMediaType } from 'technical/media/hooks';
import { isUndefinedOrNull } from 'technical/utils/is-null-or-undefined';
import { ContentTitle } from 'ui/content-title';
import { ShowMoreToggle } from 'ui/show-more-button';
import { useShowMore } from 'ui/show-more-button/hook';
import { ShowMoreContainer } from 'ui/show-more-button/show-more-container';

const COL_PROPS = {
  xs: 12,
  sm: 12,
  md: 12,
  lg: 12,
  xl: 6,
};

interface ReportProdAnalyzeAveragesProps {
  averagePerDay: string | null;
  averagePerProductionDay: string | null;
  averagePerDayAndShift: string | null;
  totalRing: string | null;
}

export const ReportProdAnalyzeAverages = ({
  averagePerDay,
  averagePerProductionDay,
  averagePerDayAndShift,
  totalRing,
}: ReportProdAnalyzeAveragesProps) => {
  const { t } = useTranslation();
  const filters = useReportProdAnalyzeFilters();
  const locale = getLocale();
  const numberFormatter = createNumberFormatter(locale);
  const { isMobile } = useMediaType();
  const { showMore, toggleShowMore } = useShowMore({ averages: false });

  return (
    <Flex vertical>
      {isMobile ? <ContentTitle>{t('common.averages')}</ContentTitle> : null}
      <ShowMoreContainer
        enableToggle={isMobile}
        toggleState={showMore.averages}
      >
        <Row gutter={8}>
          <Col {...COL_PROPS}>
            <Statistic
              title={t(
                'reportAnalyze.productionAnalyze.averages.averagePerDay',
              )}
              value={
                isUndefinedOrNull(averagePerDay)
                  ? 0
                  : numberFormatter.format(parseFloat(averagePerDay))
              }
            />
          </Col>

          <Col {...COL_PROPS}>
            <Statistic
              title={t(
                'reportAnalyze.productionAnalyze.averages.averagePerProductionDay',
              )}
              value={
                isUndefinedOrNull(averagePerProductionDay)
                  ? 0
                  : numberFormatter.format(parseFloat(averagePerProductionDay))
              }
            />
          </Col>

          <Col {...COL_PROPS}>
            <Statistic
              title={
                filters.groupByType === 'shift'
                  ? t(
                      'reportAnalyze.productionAnalyze.averages.averagePerShift',
                    )
                  : t('reportAnalyze.productionAnalyze.averages.averagePerTeam')
              }
              value={
                isUndefinedOrNull(averagePerDayAndShift)
                  ? 0
                  : numberFormatter.format(parseFloat(averagePerDayAndShift))
              }
            />
          </Col>

          <Col {...COL_PROPS}>
            <Statistic
              title={t('reportAnalyze.productionAnalyze.averages.totalRing')}
              value={
                isUndefinedOrNull(totalRing)
                  ? 0
                  : numberFormatter.format(parseFloat(totalRing))
              }
            />
          </Col>
        </Row>
      </ShowMoreContainer>
      <ShowMoreToggle
        enableToggle={isMobile}
        toggleState={showMore.averages}
        toggleFunc={toggleShowMore('averages')}
      />
    </Flex>
  );
};
